module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/code-c434045758164838a3322f919710ed2f.svg";